export default __webpack_public_path__ + "static/media/nft_3.98ad4040.jpg";